export const ExportButtonConstant = {
  SuccessMessage: ['Your exported results will be sent to you via email. This can take up to 5 minutes.', 'If you do not receive an email after this time, please try again.'],
  ErrorMessage: ['We\'ve had a technical issue. Please try exporting again.'],
};
